import React from 'react';
import Tooltip from '@gik/ui/Tooltip';

export enum IconButtonStyle {
  Edit = 'edit',
  Delete = 'delete',
  Share = 'share',
  White = 'white',
  Transparent = 'transparent',
  Organiser = 'organiser',
  Copy = 'copy',
}

interface IconButtonProps {
  icon: string;
  style: IconButtonStyle;
  tooltip?: string;
  id?: string;
  className?: string;
  onClick(e: React.MouseEvent): void;
  onDisabledClick?(e: React.MouseEvent): void;
  onMouseLeave?(): void;
  disabled?: boolean;
  allowTooltipOnMobile?: boolean;
}

export default class IconButton extends React.PureComponent<IconButtonProps> {
  private onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (this.props.disabled !== true) {
      this.props.onClick(e);
    } else {
      this.props.onDisabledClick && this.props.onDisabledClick(e);
    }
  };

  render() {
    const button = (
      <button
        id={this.props.id}
        className={`icon-button ${this.props.disabled ? 'disabled' : ''} ${this.props.style} ${
          this.props.className || ''
        }`}
        onClick={this.onClick}
        onMouseLeave={this.props.onMouseLeave}
      >
        <i className={`gik-icon-v2 icon-v2-${this.props.icon}`}></i>
      </button>
    );
    return this.props.tooltip ? (
      <Tooltip text={this.props.tooltip} allowOnMobile={this.props.allowTooltipOnMobile}>
        {button}
      </Tooltip>
    ) : (
      button
    );
  }
}
